import { render } from "./yuvak-mandal.vue?vue&type=template&id=ec328228&scoped=true"
import script from "./yuvak-mandal.vue?vue&type=script&lang=js"
export * from "./yuvak-mandal.vue?vue&type=script&lang=js"

import "./yuvak-mandal.vue?vue&type=style&index=0&id=ec328228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec328228"]])

export default __exports__